export interface AppLink {
  clientId: string;
  name: string;
  url: string;
}

// Apps served by this identity provider, listed on the standalone landing
// (when someone opens auth directly, without an authorization request).
export const APPS: AppLink[] = [
  { clientId: 'shop', name: 'Shop', url: 'https://shop.smndiaye.com' },
  { clientId: 'qlearn', name: 'QLearn', url: 'https://qlearn.smndiaye.com' },
  { clientId: 'bukku', name: 'Bukku', url: 'https://bukku.smndiaye.com' },
  { clientId: 'files', name: 'Files', url: 'https://files.smndiaye.com' },
];

// Display name for a validated client_id, or null if we don't recognise it.
export function nameForClientId(id: string): string | null {
  return APPS.find((a) => a.clientId === id)?.name ?? null;
}
